import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchStoreLocations } from "../../api_calls/infrastructure";
import { createCookie, deleteCookie } from "../../api_calls/requestConfig";
import { deleteItems, updateStateData } from "../../Store/actions";
import FilterPanel from "../../components/commonComponents/Filters/FilterPanel";

const InfraFilters = (props) => {
  const infraDetails = useSelector((state) => state.userSelections);

  const dispatchAction = useDispatch();

  const infraFiltersConfig = React.useMemo(
    () => [
      {
        key: "ip_filter",
        label: "IP Address",
        type: "multi",
        options: () => infraDetails.store_ip_list || [],
      },
      {
        key: "store_name",
        label: "Store Name",
        type: "multi",
        options: () =>
          typeof infraDetails.store_names_info !== "undefined"
            ? infraDetails.store_names_info.store_names_list
            : [],
      },
      {
        key: "owner",
        label: "Owner",
        type: "multi",
        options: () => infraDetails.companies_info || [],
      },
      {
        key: "status",
        label: "Status",
        disableSearch: true,
        type: "single",
        selectionParam: "label",
        options: () => [
          { value: 1, label: "Active" },
          { value: 2, label: "Inactive" },
        ],
      },
    ],
    [infraDetails]
  );

  const saveStoreFilters = (filters) => {
    const filterValues = {
      ip_filter: filters.ip_filter || [],
      store_name: filters.store_name || [],
      store_company_filter: filters.owner || [],
      status_filter: filters.status || [],
    };
    const noFiltersSelected =
      (!filterValues.ip_filter || filterValues.ip_filter.length === 0) &&
      (!filterValues.store_name || filterValues.store_name.length === 0) &&
      (!filterValues.store_company_filter || filterValues.store_company_filter.length === 0) &&
      (!filterValues.status_filter || filterValues.status_filter.length === 0);
    if (noFiltersSelected) {
      // If nothing is selected, clear existing filters and return
      clearfilters();
      return;
    }
    // Persist filters to Redux for later retrieval
    dispatchAction(
      updateStateData({
        store_list_filters: filterValues,
        store_list_filter_applied: true,
      })
    );
    // Persist to cookie for session persistence
    createCookie("store_list_filters", JSON.stringify(filterValues));
    // Reload stores (reset to page 1 but retain page size)
    fetchStoreLocations(0, infraDetails.stores_pagination.pageSize);
  };

  const clearfilters = () => {
    deleteCookie("store_list_filters", true);
    dispatchAction(deleteItems(["store_list_filters", "store_list_filter_applied"]));
    fetchStoreLocations(0, infraDetails.stores_pagination.pageSize);
  };

  if (
    typeof infraDetails.store_names_info === "undefined" ||
    typeof infraDetails.companies_info === "undefined"
  ) {
    return null;
  }

  return (
    <FilterPanel
      filtersConfig={infraFiltersConfig}
      applyFilterFunc={saveStoreFilters}
      clearFilterFunc={clearfilters}
      initiallyAppliedVals={infraDetails.store_list_filters}
    />
  );
};

export default InfraFilters;
